import { useContext, useEffect, useState } from "react";
import {
  WindowDimensions,
  WindowDimensionsContext,
  WindowDimensionsProviderProps,
  getWindowDimensions,
} from "./WindowDimensions.Parts";

export const WindowDimensionsProvider = ({
  children,
}: WindowDimensionsProviderProps) => {
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>(
    getWindowDimensions(),
  );

  useEffect(() => {
    let animationFrameId: number | null = null;

    const handleResize = () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);

      animationFrameId = requestAnimationFrame(() =>
        setWindowDimensions(getWindowDimensions()),
      );
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <WindowDimensionsContext.Provider value={windowDimensions}>
      {children}
    </WindowDimensionsContext.Provider>
  );
};

export const useWindowDimensions = (): WindowDimensions => {
  const windowDimensions = useContext(WindowDimensionsContext);

  if (!windowDimensions) {
    throw new Error(
      "useWindowDimensions must be used within a <WindowDimensionsProvider />",
    );
  }

  return windowDimensions;
};
